import { IAccMonKhongTinhHocPhi } from "../../model/respone/category/IAccMonKhongTinhHocPhi";
import { apiClient } from "../apiClient";
export const MON_KHONG_TINH_HOC_PHI_ENDPOINT = "mon-khong-tinh-hoc-phi";
export const monKhongTinhHocPhiApi = {
  SelectAll: () => apiClient.get(`${MON_KHONG_TINH_HOC_PHI_ENDPOINT}`),
  Insert: (payload: IAccMonKhongTinhHocPhi) =>
    apiClient.post(`${MON_KHONG_TINH_HOC_PHI_ENDPOINT}`, payload),
  Update: (payload: IAccMonKhongTinhHocPhi) =>
    apiClient.put(`${MON_KHONG_TINH_HOC_PHI_ENDPOINT}`, payload),
  Delete: (id: number) =>
    apiClient.delete(`${MON_KHONG_TINH_HOC_PHI_ENDPOINT}/${id}`),
};
